import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadStatusService {

  constructor(private ws: PostmethodService) { }

  leadStatusCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "LeadstatusesMaster");
  }
}
